import React from 'react';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import { ExpandMore } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import { colors, fontSize } from '../../../constants/styleConstants';
import DateFilter from './dateFilter';

const useStyles = makeStyles({
  content: {
    borderRadius: '8px',
    border: `solid 1px ${colors.border.grey1}`,
    backgroundColor: colors.white,
    '&:hover': {
      border: `solid 1px ${colors.blue3}`,
      backgroundColor: colors.blue1,
    },
  },
  selected: {
    borderRadius: '8px',
    border: `solid 1px ${colors.blue3}`,
    backgroundColor: colors.blue1,
    '&:hover': {
      border: `solid 1px ${colors.blue3}`,
      backgroundColor: colors.blue1,
    },
    color: colors.blue3,
    fontWeight: 'bold',
  },
  icon: {
    color: colors.blue3,
    fontSize: fontSize.large,
  },
  iconClose: {
    color: colors.blue3,
    fontSize: fontSize.medium,
  },
  disabledIcon: {
    color: 'rgba(0, 0, 0, 0.26)',
  },
  customStyle: {
    textTransform: 'none',
    fontSize: fontSize.smallTitle,
    margin: '2px 4px 2px 0px',
    marginRight: '8px',
  },
  label: {
    marginLeft: '8px',
  },
  popper: {
    maxWidth: '400px',
    maxHeight: '300px',
    zIndex: '998',
    border: `solid 1px ${colors.grey}`,
  },
});

export default function FBDropdownButton({
  label,
  state,
  dispatch,
  type,
  onSubmit,
  options,
  getSelectedValue,
  isSmall,
  tabViewType,
  seasonsOptions,
}) {
  const selectedValue = getSelectedValue(state, type);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(selectedValue || -1);

  React.useEffect(() => {
    setSelectedIndex(selectedValue || -1);
  }, [options, isSmall, selectedValue]);

  const resetFilter = filterType => {
    if (
      filterType === 'language_id' ||
      filterType === 'subtitle_id' ||
      filterType === 'country_id' ||
      filterType === 'year_id' ||
      filterType === 'season_id'
    ) {
      dispatch({
        type: 'RESET_FILTERS',
        payload: filterType,
      });
    }
  };

  const handleMenuItemClick = (filterType, index, value) => {
    setSelectedIndex(value);
    if (value == -1) resetFilter(filterType);
    onSubmit && onSubmit({ filterType, selectedValue: value != -1 ? options[index] : null });
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const menuOptions = (options?.length > 2 || type === 'date') && (
    <MenuList id="split-button-menu">
      {options.map((option, index) => (
        <MenuItem
          key={option.id}
          selected={option.id === selectedIndex}
          onClick={() => handleMenuItemClick(type, index, option.id)}
        >
          {option.name}
        </MenuItem>
      ))}
    </MenuList>
  );
  return (
    <>
      {(options?.length > 2 || (type === 'date' && options?.length > 0)) && (
        <Button
          size="small"
          aria-expanded={open ? 'true' : undefined}
          aria-label={label}
          aria-haspopup="menu"
          onClick={handleToggle}
          disabled={type === 'date' && tabViewType === 'upcoming'}
          className={classnames(open ? classes.selected : classes.content, classes.customStyle)}
          ref={anchorRef}
        >
          <span className={classes.label}> {options?.filter(item => item.id == selectedIndex)[0]?.name}</span>

          {selectedIndex === -1 || type === 'year_id' ? (
            <ExpandMore
              className={classnames(
                classes.icon,
                type === 'date' && tabViewType === 'upcoming' && classes.disabledIcon,
              )}
            />
          ) : (
            <CloseIcon
              className={classes.iconClose}
              onClick={e => {
                e.stopPropagation();
                handleMenuItemClick(type, 0, -1);
              }}
            />
          )}
        </Button>
      )}

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        className={classes.popper}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                {type === 'date' ? (
                  <MenuList id="split-button-menu">
                    <DateFilter
                      state={{ ...state }}
                      dispatch={dispatch}
                      onSubmit={onSubmit}
                      handleToggle={handleToggle}
                      seasonsOptions={seasonsOptions}
                    />
                  </MenuList>
                ) : (
                  menuOptions
                )}
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
